import { render, staticRenderFns } from "./legal_agreement_detail.vue?vue&type=template&id=1dc2641d&scoped=true"
import script from "./legal_agreement_detail.vue?vue&type=script&lang=js"
export * from "./legal_agreement_detail.vue?vue&type=script&lang=js"
import style0 from "./legal_agreement_detail.vue?vue&type=style&index=0&id=1dc2641d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2641d",
  null
  
)

export default component.exports